import React from "react";

export default function Footer() {
	return (
		<footer className="app-footer">
			<p>
				To add your own rejection story, please{" "}
				<a href="https://github.com/Rejectedus/rejected.us/pulls/">
					open a PR
				</a>{" "}
				or tweet me at <a href="https://x.com/jkup">@jkup</a>
			</p>
			<p>
				Created by <a href="https://jonkuperman.com">Jon Kuperman</a>
			</p>
		</footer>
	);
}
